import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar.tsx";
import Footer from "./Components/Footer.tsx";
import Home from "./Pages/Home.tsx";

import ConsentForm from "./Pages/ConsentForm.tsx";
import Under18ConsentForm from "./Pages/Under18ConsentForm.tsx";
import BodyPiercingRecord from "./Pages/BodyPiercingRecord.tsx";
import TattooConsentForm from "./Pages/TattooConsentForm.tsx";
import { Box } from "@mui/material";
import CustomerConsents from "./Pages/Customers.tsx";
import { Login } from "@mui/icons-material";
import SignIn from "./Pages/SignIn.tsx";
import ForgotPassword from "./Pages/ForgotPassword.tsx";

const App = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Box sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/consent" element={<ConsentForm />} />
          <Route path="/customer" element={<CustomerConsents />} />
          <Route path="/under18consent" element={<Under18ConsentForm />} />
          <Route path="/body-piercing-record" element={<BodyPiercingRecord />} />
          <Route path="/tattoo-consent" element={<TattooConsentForm />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
};

export default App;
